import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-bookmoreoptions',
  templateUrl: './bookmoreoptions.component.html',
  styleUrls: ['./bookmoreoptions.component.css']
})
export class BookmoreoptionsComponent implements OnInit {
  @Input() data: any;
  moreRoundOption = [{ "name": "Online Enrichment", "icon": "icon-Online-Enrichment" }, { "name": "Feedback", "icon": "icon-Feedback" }, { "name": "Reports", "icon": "icon-Reports" }, { "name": "Print", "icon": "icon-Print" }]
  constructor() { }

  ngOnInit() {
  }

  selectMoreOption(opt, ind, evt) {
   
    evt.stopPropagation();
    //this.data.popupProps.showPopup = false;

    // setTimeout(() => {
    //   if (opt == "Print")
    //     window.print();
    // }, 0);

  }
}



// WEBPACK FOOTER //
// ./src/app/bookShared/popups/bookmoreoptions/bookmoreoptions.component.ts